export default "__VITE_ASSET__MZuy2gVF__";